import { defineMessages } from '../../i18n/messages';
import { englishText } from '../../utils/messageFallbacks';

const CONSENT_DEFINITIONS = {
    REGION_LABEL: {
        id: 'consent.banner.region_label',
        text: 'Cookie consent',
        description:
            'Accessible name of the consent banner region, announced by screen readers. Not visible on screen.',
    },
    TITLE: {
        id: 'consent.banner.title',
        text: 'Analytics and advertising cookies',
        description: 'Heading of the cookie consent banner pinned to the bottom of the page',
    },
    BODY: {
        id: 'consent.banner.body',
        text: 'We would like to measure how visitors find and use Localingos, and which ads bring developers here. Nothing is stored on your device or shared with Google until you choose to allow it.',
        description:
            'Explanation in the cookie consent banner, between the heading and the Allow / Decline buttons. Must state plainly that no tracking happens before the visitor agrees.',
    },
    ACCEPT: {
        id: 'consent.banner.accept',
        text: 'Allow',
        description:
            'Label of the button that grants consent for analytics and advertising cookies. Keep it short — it sits next to the Decline button and both are the same size.',
    },
    DECLINE: {
        id: 'consent.banner.decline',
        text: 'Decline',
        description:
            'Label of the button that refuses analytics and advertising cookies. Keep it short — it sits next to the Allow button and both are the same size.',
    },
};

export const ConsentMessages = defineMessages(CONSENT_DEFINITIONS);

/** English fallbacks, used until `npm run i18n:extract` adds these ids to en-US.json. */
export const ConsentText = englishText(CONSENT_DEFINITIONS);
